// src/store/services/users.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class RectificacionesAprobarComplemento extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'RectificacionesAprobarComplemento';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'rectificaciones-aprobar-complemento';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'RectificacionesAprobarComplemento',
    Model: RectificacionesAprobarComplemento,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  